<template>
  <div>
    <div class="searchable-scrollbox mb-3" data-component="SearchableScrollbox">
      <input type="hidden" value="radio" class="js-search-box-type">
      <input
        type="search"
        id="search"
        class="form-control searchable-scrollbox__search js-search-box-input"
        :placeholder="field.specification.placeholder"
      >

      <div class="searchable-scrollbox__content js-search-box-content" ref="box">
        <div class="searchable-scrollbox__row" v-for="(item, index) in items" :key="index" :data-title="item.title">
          <div class="searchable-scrollbox__input">
            <input
              :type="inputType"
              :id="`item-${index}-${id}`"
              :value="item.key"
              :name="isMulti ? `item-${index}-${id}` : `item-${id}`"
              @change="handleUpdate"
              :checked="typeof content !== 'undefined' && content.indexOf(item.key) >= 0"
            >
            <label :for="`item-${index}-${id}`">{{ item.title }}</label>
          </div>
        </div>
      </div>

      <div class="searchable-scrollbox__actions">
        <button type="button" class="searchable-scrollbox__action" @click="select(true)">Selecteer alles</button>
        <button type="button" class="searchable-scrollbox__action" @click="select(false)">Deselecteer alles</button>

        <span class="text-muted ml-auto" v-if="items">
          {{ items.length }} {{  items.length === 1 ? 'resultaat' : 'resultaten' }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import debounce from '../../../helpers/debounce';

  export default {
    props: ['id', 'field'],

    data() {
      const isMulti = typeof this.field.specification.multi !== 'undefined' && this.field.specification.multi;

      return {
        items:  null,
        content: this.field.value,
        inputType: isMulti ? 'checkbox' : 'radio',
        isMulti,
      };
    },

    mounted() {
      window.axios
        .get(this.field.specification.api)
        .then((response) => {
          const items = response.data;

          if (typeof this.content === 'string' || typeof this.content === 'undefined') {
            this.items = items;
            return;
          }

          const selectedInputs = this.content.map((input) => {
            return input;
          }).join();

          items.sort((a) => {
            if (selectedInputs.indexOf(a.key) >= 0) {
              return -1;
            }

            return 1;
          });

          this.items = items;
        });

      const searchDebounced = debounce((search) => {
        this.searchList(search.length > 2 ? search : '');
      }, 200);

      this.$el.querySelector('.js-search-box-input').addEventListener('keyup', (e) => {
        const search = e.currentTarget.value;
        searchDebounced(search);
      });
    },

    methods: {
      handleUpdate() {
        const wrapper = this.$refs.box;
        let value;

        if (this.isMulti) {
          value = Array.prototype.slice.call(wrapper.querySelectorAll('input:checked'))
            .map(element => element.value);
        } else {
          const checked = wrapper.querySelector('input:checked');
          value = checked.value;
        }

        this.$emit('field-update', this.field.key, value);
      },

      searchList(search) {
        const items = this.getAllItems();
        const normalizedSearch = this.normalizeSearch(search);

        items.forEach((item) => {
          if (search === '') {
            item.style.display = 'flex';
            return;
          }

          const inTitle = this.normalizeSearch(item.dataset.title).indexOf(normalizedSearch) >= 0;

          item.style.display = inTitle ? 'flex' : 'none';
        });
      },

      select(state) {
        const visibleItems = this.getAllItems().filter(item => !item.style.display || item.style.display === 'flex');

        visibleItems.forEach((item) => {
          item.querySelector(`input[type="${this.inputType}"]`).checked = state;
        });
      },

      getAllItems() {
        return Array.prototype.slice.call(this.$el.querySelector('.js-search-box-content').childNodes).filter(node => node.nodeName === 'DIV');
      },

      normalizeSearch(search) {
        return search.toLowerCase().trim().replace(/[\s-]/g, '');
      },
    },
  };
</script>
